import React, { useEffect, useState } from "react"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import { couriersForMethod } from "../../../helpers/courier";

const ShippedOrder = (props) => {
    const [courierService, setCourierService] = useState();
    const [trackingNum, setTrackingNum] = useState();
    const [trackingUrl, setTrackingUrl] = useState();
    const [shippingMethod, setShippingMethod] = useState();

    useEffect(() => {
        if (props?.orderData) {
            setShippingMethod(props?.orderData?.shipping_method_id || '');
        }
    }, [props?.orderData])

    const handleSubmit = () => {
        let payload = {
            shipping_method_id: shippingMethod,
            courier_service: courierService,
            tracking_no: trackingNum,
            tracking_url: trackingUrl,
        }
        props.submit(payload);
    }

    const selectedMethod = (props?.shippingMethodList || []).find((item) => String(item.id) === String(shippingMethod));
    const courierOptions = couriersForMethod(selectedMethod, courierService);

    return (
        <AppDialog
            open={props.open}
            close={() => props.close()}
            title={'Mark as shipped'}
            titleIcon={'complete'}
            positiveTitle={'Mark as shipped'}
            positivePress={() => handleSubmit()}
            negativePress={() => props.close()}
            negativeTitle={'Cancel'}
            width={'40%'}
        >
            <div className="">
                <div className="mb-3">
                    Please enters the tracking details and confirm to set the order status to “Shipped”.
                </div>
                <CustomSelect
                    title={'Shipping method'}
                    values={shippingMethod || '-1'}
                    placeholder={'Please select'}
                    labelName={'title'}
                    data={props?.shippingMethodList || []}
                    onChange={(value) => {
                        setShippingMethod(value);
                        const nextMethod = (props?.shippingMethodList || []).find((item) => String(item.id) === String(value));
                        const nextCouriers = couriersForMethod(nextMethod);
                        if (!nextCouriers.some((row) => row.value === courierService || row.label === courierService)) {
                            setCourierService('');
                        }
                    }}
                />
                <div className="mt-3">
                    <CustomSelect
                        title={'Courier service'}
                        values={courierService || '-1'}
                        placeholder={'Please select'}
                        data={courierOptions}
                        onChange={setCourierService}
                    />
                </div>
                <div className="mt-3">
                    <CustomTextField
                        title={'Tracking Number'}
                        values={trackingNum}
                        onChange={setTrackingNum}
                    />
                </div>
                <div className="mt-3">
                    <CustomTextField
                        title={'Tracking URL'}
                        values={trackingUrl}
                        onChange={setTrackingUrl}
                    />
                </div>
            </div>
        </AppDialog>
    )
}

export default ShippedOrder;